

const ruTranslations = {
  title: "Artem Ryabinin",
  profile: {
    title: "Профиль",
    content: "IT-разработчик с более чем 15-летним опытом в индустрии. Эксперт в области full-stack разработки с глубокими знаниями в backend-технологиях и применении ИИ в разработке. Успешный опыт реализации проектов для крупных корпораций и стартапов, сочетающий технические навыки с стратегическим мышлением и лидерскими качествами."
  },
  expertise: {
    title: "Области специализации",
    items: [
      "Веб-разработка (сайты, информационные порталы)",
      "Корпоративное ПО (CRM и ERP системы)",
      "Разработка кастомного ПО под уникальные задачи бизнеса",
      "Разработка чат-ботов и ИИ-ассистентов",
      "Разработка мобильных приложений",
      "Системы дополненной реальности",
      "Аудит безопасности и поиск уязвимостей",
      "Бизнес-аналитика и системный анализ",
      "Обработка и анализ больших данных с использованием ML и TensorFlow",
      "Разработка и обучение нейросетей для анализа социальных сетей",
      "Решение сложных задач и проведение исследований в области ИИ",
      "Проектирование и реализация микросервисной архитектуры",
      "Контейнеризация приложений с использованием Docker",
      "Интеграция и развертывание приложений в облачной инфраструктуре AWS"
    ]
  },
  skills: {
    title: "Ключевые навыки",
    items: [
      "Языки программирования: Go, Python, TypeScript/JavaScript, PHP (ранний опыт)",
      "Фреймворки: Django, React, GIN",
      "Специализация на backend-разработке, глубокие знания в области серверной архитектуры",
      "Full-stack разработка с сильным уклоном в backend",
      "UX/UI дизайн",
      "Управление проектами и командами разработчиков",
      "Применение нейросетей в разработке",
      "Адаптация к новым технологиям и методологиям",
      "Оптимизация бизнес-процессов, включая вендерение AI систем",
      "Проектирование и реализация микросервисной архитектуры",
      "Контейнеризация приложений с использованием Docker",
      "Развертывание и управление приложениями в AWS",
      "Работа с базами данных: PostgreSQL, MongoDB",
      "Опыт в разработке и оптимизации высоконагруженных систем"
    ]
  },
  achievements: {
    title: "Профессиональные достижения",
    items: [
      "Увеличил эффективность разработки на 28% путем внедрения ИИ-инструментов в рабочий процесс",
      "Успешно завершил более 50 проектов для клиентов из Fortune 500",
      "Основал высокоприбыльную компанию RownArts, которая быстро стала лидером в своей нише",
      "Разработал и внедрил инновационную систему оптимизации рабочих процессов, повысившую производительность команды на 32%"
    ]
  },
  experience: {
    title: "Опыт работы",
    jobs: [
      {
        title: "Фрилансер и Independent Developer",
        period: "2020 - настоящее время",
        details: [
          "Специализация на backend-разработке (преимущественно Go и Python)",
          "Реализация высоконагруженных проектов для МГУ, Сбербанка и различных криптопроектов",
          "С 2021 года применяю ИИ для оптимизации разработки и анализа данных",
          "Разработка и внедрение инновационных backend-решений для оптимизации производительности"
        ]
      },
      {
        title: "UX/UI специалист и React разработчик, Neurodoc",
        period: "2019",
        details: [
          "Создание с нуля ui/ux системы Neurodoc в короткие сроки",
          "Разработка отзывчивых и доступных frontend-решений с использованием React"
        ]
      },
      {
        title: "Ведущий Frontend-разработчик, RedCrypto",
        period: "2018",
        details: [
          "Руководство командой из 5 разработчиков",
          "Внедрение методологии Agile, сократившей время выпуска продукта на 40%"
        ]
      },
      {
        title: "Основатель и Team Lead, RownArts",
        period: "2013 - 2018",
        details: [
          "Рост компании от стартапа до команды из 15 специалистов",
          "Ключевая роль в привлечении и удержании клиентов уровня Bacardi, Volkswagen Group, Parliament , МТС, Аэрофлот, Сбер",
          "Разработка инновационных backend-решений на Python и Django, а также .NET MVC"
        ]
      },
      {
        title: "Project Manager, Mosaic Media",
        period: "2013, 5 месяцев",
        details: [
          "Успешное управление параллельной разработкой 3 крупных проектов",
          "Внедрение системы контроля качества, снизившей количество багов на 57%"
        ]
      },
      {
        title: "Фрилансер",
        period: "2008 - 2013",
        details: [
          "Реализация более 30 проектов различной сложности с акцентом на backend-разработку",
          "Развитие навыков full-stack разработки с фокусом на backend (PHP, затем Python) параллельно с обучением в университете",
          "Создание и оптимизация backend-систем для клиентов из различных отраслей"
        ]
      }
    ]
  },
  education: {
    title: "Образование",
    items: [
      {
        institution: "МГТУ им. Баумана",
        degree: "Машиностроение, 2013",
      }
    ]
  },
  additionalEducation: {
    title: "Дополнительное образование",
    items: [
      "Курс \"Deep Learning Specialization\" от deeplearning.ai, 2021"
    ]
  },
  earlyExperience: {
    title: "Ранний опыт",
    content: "Реализация коммерческих проектов для международных клиентов (AMK technologies, Olga Widman) в старших классах школы"
  },
  additionalInfo: {
    title: "Дополнительная информация",
    items: [
      "Активный участник open-source сообщества: контрибьютор в проекты Django и TensorFlow",
      "Ментор для начинающих разработчиков в локальном IT-сообществе",
      "Постоянное самообразование и освоение передовых технологий"
    ]
  }
};

export default ruTranslations;
